import { http } from "../api/http";
import Utils from "../utils";

export const runbookContactService = {
  get,
  getById,
  create,
  update,
  remove,
};

async function get(requestParameters) {
  let url = `/runbook-contact?${Utils.objectToQueryString(requestParameters)}`;

  const response = await http.get(url);
  return response;
}

async function getById(runbookId, emailAddress) {
  // URL encode the email address to handle special characters
  const encodedEmail = encodeURIComponent(emailAddress);
  let url = `/runbook-contact/${runbookId}/${encodedEmail}`;

  const response = await http.get(url);
  return response;
}

async function create(requestBody) {
  let url = `/runbook-contact/create`;

  const response = await http.post(url, JSON.stringify(requestBody));
  return response;
}

async function update(requestBody) {
  let url = `/runbook-contact/update`;

  return await http.patch(url, JSON.stringify(requestBody)).then((response) => {
    return response;
  });
}

async function remove(requestParameters) {
  let url = `/runbook-contact/delete?${Utils.objectToQueryString(requestParameters)}`;

  return await http.delete(url).then((response) => {
    return response;
  });
}
